import { auth } from '../firebase';
import { buildApiUrl } from '../config/env';

export const isPrivateStorageURL = (value = '') => {
  try {
    const url = new URL(value);
    return url.protocol === 'gs:' || ['firebasestorage.googleapis.com', 'storage.googleapis.com'].includes(url.hostname);
  } catch { return false; }
};

export async function finalizePrivateUpload(storagePath) {
  const token = await auth.currentUser.getIdToken();
  const response = await fetch(buildApiUrl('/storage/finalize'), {
    method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ storagePath }),
  });
  if (!response.ok) throw new Error('Unable to secure uploaded file');
  return response.json();
}

export async function loadPrivateBlob(value, signal) {
  const user = auth.currentUser;
  if (!user) throw new Error('Sign in to view this file');
  const token = await user.getIdToken();
  const response = await fetch(buildApiUrl(`/storage/content?path=${encodeURIComponent(value)}`), {
    headers: { Authorization: `Bearer ${token}` }, signal, cache: 'no-store',
  });
  if (!response.ok || auth.currentUser?.uid !== user.uid) throw new Error('Unable to access file');
  return response.blob();
}
